<icc-list
    [items]="styles"
    (select)="selectStyle($event)"
    [itemTemplate]="'itemImgTitle'"
    [itemImgHeight]="'medium'"
    [selected]="selectedStyleId">
</icc-list>
